import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  Divider,
  Button,
  Box,
} from '@mui/material';

export default function MemberUpcomingMatchesCard({ matches = [] }) {
  const [expanded, setExpanded] = useState(false);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingMatches = matches
    .filter((match) => {
      const [day, month, year] = match.matchDate.split('/').map(Number);
      const matchDate = new Date(year, month - 1, day);
      return matchDate >= today;
    })
    .sort((a, b) => {
      const [aDay, aMonth, aYear] = a.matchDate.split('/').map(Number);
      const [bDay, bMonth, bYear] = b.matchDate.split('/').map(Number);
      return new Date(aYear, aMonth - 1, aDay) - new Date(bYear, bMonth - 1, bDay);
    });

  if (!upcomingMatches.length) {
    return (
      <Card sx={{ margin: 2, padding: 2 }}>
        <CardHeader title="Upcoming Matches" />
        <CardContent>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: 'center', marginY: 2 }}
          >
            No upcoming matches.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  const displayedMatches = expanded ? upcomingMatches : upcomingMatches.slice(0, 2);

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Card sx={{ margin: 2, padding: 2 }}>
      <CardHeader title="Upcoming Matches" />
      <CardContent>
        <List>
          {displayedMatches.map((match, index) => (
            <React.Fragment key={index}>
              <ListItem
                sx={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  paddingY: 2,
                }}
              >
                <Typography variant="body2" color="textSecondary">
                  {match.matchDate}
                </Typography>
                <Typography variant="h6" color="primary">
                  {match.sportType} {match.pennantName} (Section {match.section})
                </Typography>
                
                <Typography variant="body2" color="textSecondary">
                  {match.team1?.name || 'TBD'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  VS
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {match.team2?.name || 'TBD'}
                </Typography>
              </ListItem>
              {index < displayedMatches.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
        {upcomingMatches.length > 2 && (
          <Box sx={{ textAlign: 'center', marginTop: 2 }}>
            <Button onClick={toggleExpanded}>
              {expanded ? 'Show Less' : 'Show More'}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
